<template>
  <form @submit.prevent="$emit('submit')">
    <string-form-field
      :label="$t('microCreditFile.fields.title')"
      :value="value.title"
      :error="findError('title')"
      @input="propertyChange('title', $event)"
    />

    <!--
    <micro-credit-file-status-form-field
      input-id
      output-id
      multiple
      :dropdown="false"
      :label="$t('file.fields.status')"
      :value="value.statusId"
      :error="findError('statusId')"
      @input="propertyChange('statusId', $event)"
    />
    -->

    <!--
    Il pulsante nascosto permette di sottomettere il form alla pressione
    del tasto INVIO in uno dei campi contenuti; altrimenti l'invio del
    form non avviene.
    -->
    <b-button type="submit" class="d-none"></b-button>
  </form>
</template>
<script>
import EditorMixin from "vue-template/common/mixins/EditorMixin";
//import MicroCreditFileStatusFormField from "@/modules/microcredit/filestatus/protected/MicroCreditFileStatusFormField";

export default {
  mixins: [EditorMixin]

  /*
  components: {
    MicroCreditFileStatusFormField
  }
  */
};
</script>
